import { takeLatest, put, select } from 'redux-saga/effects';
import { actions as listActions } from '../slices/LostTripListSlices';

import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';

const getSearchLostTrip = state => state.lostTripList.searchLostTrip;

function* getListLostTrip({ payload }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('get_list_lost_trip')}`, {
            params: payload,
        });
        yield put({ type: listActions.get_list_succeed.type, payload: { ...response } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_list_failed.type, payload: error });
    }
}

function* updateLostTripConformed({ payload }) {
    try {        
        yield NetworkHandler.post(`${config.getUrl('get_list_lost_trip_approve')}`, {
            ...payload
        });

        NotificationHandler.notifySuccess('Cập nhật thành công!');

        const searchLostTrip = yield select(getSearchLostTrip);
        yield put({ type: listActions.get_list.type, payload: { ...searchLostTrip } });

        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.update_lost_trip_failed.type, payload: error });
    }
}

function* exportLostTripReport({ payload }) {   
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('get_list_lost_trip')}`, {
            params: {
                ...payload,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
    } catch (error) {
        NotificationHandler.notifyError(error.message);
    }
}

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getListLostTrip);
    yield takeLatest(listActions.update_lost_trip.type, updateLostTripConformed);
    yield takeLatest(listActions.export_lost_trip.type, exportLostTripReport);

}

export default watchRequestDetail;
